import { parseProductCode } from '@webdev/product-code';
import { makeCapacities } from 'reactApp';

export function isFloatingRatePlan(config, ratePlan) {
  return config.productRatePlan_FloatingLicense.id == ratePlan.productRatePlanId;
}

function isFloatingSubscription(config, subscription) {
  return subscription.ratePlans.some((ratePlan) => {
    return isFloatingRatePlan(config, ratePlan);
  });
}

export function isFloatingLicense(config, license) {
  return license.subscriptions.some((subscription) => {
    return isFloatingSubscription(config, subscription);
  });
}

export function subscriptionGetDisplayName(config, subscription) {
  let productName = 'Subscription';
  subscription.ratePlans.forEach((ratePlan) => {
    if (makeCapacities(config).ratePlan(ratePlan).canBeDisplayed()) {
      productName = ratePlan.ratePlanName;
    }
  });
  return productName;
}

export function groupSubscriptionsByOwner(subscriptions) {
  const subscriptionsByOwner = {};
  subscriptions.forEach((sub) => {
    if (!subscriptionsByOwner[sub.accountId]) {
      subscriptionsByOwner[sub.accountId] = {};
    }
    subscriptionsByOwner[sub.accountId].name = sub.accountName;
    subscriptionsByOwner[sub.accountId].number = sub.accountNumber;
    if (!subscriptionsByOwner[sub.accountId].subscriptions) {
      subscriptionsByOwner[sub.accountId].subscriptions = [];
    }
    subscriptionsByOwner[sub.accountId].subscriptions.push(sub);
  });
  return subscriptionsByOwner;
}

export function groupSubscriptionsByOwnerAndLicenseId(config, subscriptionsByOwner) {
  const subscriptionsByOwnerAndLicenseId = {};
  for (const accountId in subscriptionsByOwner) {
    const account = subscriptionsByOwner[accountId];
    subscriptionsByOwnerAndLicenseId[accountId] = {};
    subscriptionsByOwnerAndLicenseId[accountId].name = account.name;
    subscriptionsByOwnerAndLicenseId[accountId].number = account.number;
    subscriptionsByOwnerAndLicenseId[accountId].licenseIds = {};
    account.subscriptions.forEach((subscription) => {
      const licenseId = subscription.License_Id__c;
      if (!subscriptionsByOwnerAndLicenseId[accountId].licenseIds[licenseId]) {
        subscriptionsByOwnerAndLicenseId[accountId].licenseIds[licenseId] = {
          subscriptions: [],
          productName: subscriptionGetDisplayName(config, subscription),
          licenseKey: subscription.notes,
          nSeats: 0,
        };
      }
      subscription.ratePlans.forEach((ratePlan) => {
        if (makeCapacities(config).ratePlan(ratePlan).canBeDisplayed()) {
          if (ratePlan.quantity) {
            subscriptionsByOwnerAndLicenseId[accountId].licenseIds[licenseId].nSeats +=
              ratePlan.quantity;
          }
        }
      });
      subscriptionsByOwnerAndLicenseId[accountId].licenseIds[licenseId].subscriptions.push(
        subscription,
      );

      const nonDiscountRatePlans = getNonDiscountRatePlans(subscription);

      const lastRatePlan = nonDiscountRatePlans[nonDiscountRatePlans.length - 1];

      if (nonDiscountRatePlans.length > 1) {
        subscription.mergedNonDiscountRatePlans = [
          {
            quantity: sumOfSeatsQuantity(nonDiscountRatePlans),
            productRatePlanId: lastRatePlan.productRatePlanId,
            ratePlanCharges: lastRatePlan.ratePlanCharges,
            ratePlanName: lastRatePlan.ratePlanName,
          },
        ];
      }
    });
    const ordered = {};
    Object.keys(subscriptionsByOwnerAndLicenseId[accountId])
      .sort()
      .forEach(function (key) {
        ordered[key] = subscriptionsByOwnerAndLicenseId[accountId][key];
      });
    subscriptionsByOwnerAndLicenseId[accountId] = ordered;
  }
  return subscriptionsByOwnerAndLicenseId;
}

function getNonDiscountRatePlans(subscription) {
  return subscription.ratePlans.filter((plan) => plan.hasOwnProperty('quantity'));
}

function sumOfSeatsQuantity(ratePlans) {
  return ratePlans.reduce((sum, { quantity }) => sum + quantity, 0);
}

export function getLicenseKeyByLicenseId(subscriptionsByOwnerAndLicenseId, licenseId) {
  for (const accountId in subscriptionsByOwnerAndLicenseId) {
    const account = subscriptionsByOwnerAndLicenseId[accountId];
    if (account.licenseIds[licenseId]) {
      return account.licenseIds[licenseId].licenseKey;
    }
  }
  return '';
}

export function getPreviewPeriodFromProductCode(productCode) {
  if (!productCode) {
    return null;
  }
  const { billingCycle } = parseProductCode(productCode);
  return billingCycle === 'MO' ? 'month' : 'year';
}
